import React, { Fragment, useState, useEffect } from 'react';
import {
    Button, Dialog, DialogTitle, DialogContent, makeStyles, Grid,
    Radio, RadioGroup, FormControlLabel, FormControl, Backdrop, CircularProgress, Divider,
    TextField
} from '@material-ui/core';
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from 'notistack';
//componentes del sistema
import { palette, useStylesGlobal } from 'configurations/styles/theme';
import { useSelector } from 'react-redux';
import { getRUCEmpresa } from 'redux/actions/userActions';
import clientBackend from 'configurations/axios';
import Alert from 'widgets/alert';
import useForm from 'hooks/useFrom';
import validations from '../validations';
import { API_POST_SAVE_PROVIDERS, API_GET_ALL_LOCATIONS } from '../apis';
import { useStylesApp } from 'hooks/useStyles';
import Autocomplete from "@material-ui/lab/Autocomplete";
import PersonAddIcon from '@material-ui/icons/PersonAdd';

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(0),
        minWidth: 120,
    },
    radio: {
        display: '-webkit-box',
        marginTop: '0px'
    },
    radioLable: {
        color: palette.primary.main,
        display: 'flex'
    },
    radioButton: {
        marginTop: '0px',
        paddingTop: '0px'
    },
    divForm: {
        marginBottom: '1%',
    },
    divInput: {
        marginBottom: '1%',
        paddingRight: '1%',
        paddingLeft: '0.5%'
    },
    divButton: {
        paddingLeft: '3%',
        paddingRight: '3%'
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: palette.primary.main,
    },
}));

const AddProviderBtn = ({ updateView }) => {
    const classes = useStyles();
    const classesApp = useStylesApp();
    const classesGlobal = useStylesGlobal();
    const [openLoader, setOpenLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const [pasaporteCheck, setPasaporteCheck] = useState("C");
    const [location, setLocation] = useState([]);
    const [loadLocation, setLoadLocation] = useState(true);
    const [selectedLocation, setSelectedLocation] = useState({
        idUbicacionGeografica: "",
    });
    const userToken = useSelector(state => state.user.tk);
    const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
    const { enqueueSnackbar } = useSnackbar();
    const [options, setOptions] = useState([]);
    const [provider, setProvider] = useState({
        idEmpresa: userToken ? getRUCEmpresa(userToken) : "0",
        idCliente: "",
        nombres: "",
        coordenadasSucursal: "",
        correoCliente: "",
        digitoVerificador: "",
        direccion: "",
        identificacionExtranjera: "",
        paisExtranjero: "",
        sucursal: "",
        telefono: "",
        tipoContribuyente: "",
        tipoReceptor: "",
        paisReceptor: "",
        paisReceptorDesc: "",
        existeTablaPaises: false,
    });
    const [existCountry, setExistCountry] = useState(false);
    const [foundCountry, setFoundCountry] = useState({});
    const [openCountry, setOpenCountry] = useState(false);
    const loading = openCountry && options.length === 0;
    const existError = () => {
        setOpenLoader(false);
    }

    useEffect(() => {
        if (foundCountry !== null) {
            if (foundCountry.codigo === "ZZZ") {
                setProvider({
                    ...provider,
                    paisReceptor: foundCountry.codigo,
                    existeTablaPaises: false,
                });
                getObject({
                    ...provider,
                    paisReceptor: foundCountry.codigo,
                    ubicacionGeografica:
                        selectedLocation !== null
                            ? selectedLocation.idUbicacionGeografica
                            : "",
                    existeTablaPaises: false,
                });
            } else if (foundCountry.codigo !== "") {
                setProvider({
                    ...provider,
                    paisReceptor: foundCountry.codigo,
                    existeTablaPaises: true,
                });
                getObject({
                    ...provider,
                    paisReceptor: foundCountry.codigo,
                    ubicacionGeografica:
                        selectedLocation !== null
                            ? selectedLocation.idUbicacionGeografica
                            : "",
                    existeTablaPaises: true,
                });
            }
        }
    }, [foundCountry]);

    useEffect(() => {
        if (pasaporteCheck === "P") {
            setProvider({
                ...provider,
                identificacionExtranjera: provider.idCliente,
            });
        } else if (pasaporteCheck === "C") {
            setProvider({
                ...provider,
                identificacionExtranjera: "",
            });
        }
        getObject({
            ...provider,
        });
    }, [pasaporteCheck, provider.idCliente]);

    useEffect(() => {
        getObject({
            ...provider,
            ubicacionGeografica:
                selectedLocation !== null ? selectedLocation.idUbicacionGeografica : "",
            paisReceptor: foundCountry.codigo,
        });
    }, [selectedLocation, provider.tipoReceptor]);

    useEffect(() => {
        if (selectedLocation) {
            setProvider({
                ...provider,
                idUbicacionGeografica: selectedLocation.idUbicacionGeografica,
            });
        }
    }, [selectedLocation]);

    const handleSave = async () => {
        setOpenLoader(true);
        await clientBackend.post(API_POST_SAVE_PROVIDERS, provider).then(
            response => {
                if (response.status === 200) {
                    enqueueSnackbar("Proveedor almacenado.", {
                        variant: 'success',
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        },
                        autoHideDuration: 10000,
                    });
                    updateView();
                    setOpenLoader(false);
                    setOpen(false);
                }
            }
        ).catch(
            exception => {
                if (exception.response) {
                    if (exception.response.status === 400) {
                        setMsg({ show: true, msg: 'No se pudo almacenar el proveedor.' });
                    } else if (exception.response.status === 404) {
                        setMsg({ show: true, msg: 'No se encontró la empresa enviada para relacionarla con el proveedor.' });
                    } else if (exception.response.status === 409) {
                        setMsg({ show: true, msg: 'El proveedor ya existe.' });
                    } else if (exception.response.status === 406) {
                        setMsg({ show: true, msg: `${exception.response.data.apierror.mensajeSistema}` });
                    } else {
                        setMsg({ show: true, msg: 'Error al registrar el proveedor. Contáctese con el administrador del Sistema.' });
                    }
                } else {
                    setMsg({ show: true, msg: 'Existen problemas en la red. Contáctese con el administrador del Sistema.' });
                }
                setOpenLoader(false);
            }
        );
    }

    const { errors, handleSubmit, getObject } = useForm(handleSave, validations.addProvider, existError);

    function closeAlert() { setMsg({ show: false }); }


    const handleClickOpen = () => {
        setOpen(true);
        setLoadLocation(true);
        setProvider({ idEmpresa: userToken ? getRUCEmpresa(userToken) : "0", tipoContribuyente: '1', tipoReceptor: "01" });
        setMsg({ show: false, msg: null, type: null });
        errors.idCliente = null;
        errors.nombres = null;
        errors.correoCliente = null;
        errors.telefono = null;
        errors.digitoVerificador = null;
        errors.paisExtranjero = null;
        errors.sucursal = null;
        errors.coordenadasSucursal = null;
        errors.paisExtranjero = null;
        errors.tipoContribuyente = null;
        errors.paisReceptor = null;
        setSelectedLocation({ ubicacionGeografica: "" });
        setFoundCountry({});
        setPasaporteCheck("C");
    };

    const handleClose = () => {
        setOpen(false);
        setLocation([]);
    };

    const getLocations = async (token) => {
        setLoadLocation(false);
        if (open) {
            await clientBackend
                .get(API_GET_ALL_LOCATIONS)
                .then((result) => {
                    if (result.status === 200) {
                        let locations = result.data;
                        for (let i = 0; i < locations.length; i++) {
                            locations[i].label =
                                locations[i].nombre +
                                " / " +
                                locations[i].secuencial;
                        }
                        setLocation(locations);
                    }
                })
                .catch((exception) => {
                    setLocation([{ label: "Error al cargar las ubicaciones geográficas" }]);
                    setMsg({
                        show: true,
                        msg: "Ocurrió un problema al cargar las ubicaciones geográficas.",
                    });
                });
        }
    };

    const renderLocations = () => {
        if (location.length === 0 && userToken && loadLocation) {
            getLocations(userToken);
        }
        return (
            <>
                <Autocomplete
                    value={selectedLocation}
                    onChange={(event, newValue) => {
                        setSelectedLocation(newValue);
                    }}
                    options={location}
                    getOptionLabel={(option) => option.label}
                    style={{ width: "95%" }}
                    loading={location.length === 0}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de ubicaciones geográficas"
                            classes={{ root: classes.textFieldComboBox }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {location.length === 0 ? (
                                            <CircularProgress color="inherit" size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                />
                {errors.ubicacionGeografica ? (
                    <p className={classesApp.errorLetters}>
                        {errors.ubicacionGeografica}
                    </p>
                ) : null}
            </>
        );
    };

    //método para la busqueda para el pais
    const searchCountry = async (params) => {
        await clientBackend
            .get(`/admin/pais/buscar?parametroBusqueda=${params}`)
            .then((response) => {
                if (response.status === 200) {
                    if (Array.isArray(response.data)) {
                        if (response.data.length > 0) {
                            setOptions(
                                response.data.map(function (data, index, array) {
                                    return {
                                        id: data.id,
                                        codigo: data.codigo,
                                        nombre: data.nombre,
                                    };
                                })
                            );
                            setExistCountry(false);
                        } else {
                            setOptions([
                                {
                                    id: "",
                                    codigo: "",
                                    nombre: "No se encontró datos con el argumento ingresado",
                                },
                            ]);
                            setExistCountry(true);
                        }
                    }
                    setOpen(true);
                }
            })
            .catch((exception) => {
                if (exception.response) {
                    setOptions([
                        {
                            id: "",
                            codigo: "",
                            nombre: "No se encontró datos con el argumento ingresado",
                        },
                    ]);
                } else {
                    setOptions([
                        {
                            id: "",
                            codigo: "",
                            nombre: "Error en la red al consultar el cliente.",
                        },
                    ]);
                }
            });
    };

    const handleChangeCheck = event => {
        setPasaporteCheck(event.target.value);
        if (pasaporteCheck == "P") {
            setProvider({
                ...provider,
                identificacionExtranjera: provider.idCliente,
            });
        }
        getObject({
            ...provider,
            typeDocument: event.target.value
        });
    }

    const handleChange = event => {
        setProvider({
            ...provider,
            [event.target.name]: event.target.value
        });
        getObject({
            ...provider,
            paisReceptor: foundCountry !== null ? foundCountry.codigo : null,
            ubicacionGeografica: selectedLocation !== null ? selectedLocation.idUbicacionGeografica : "",
            [event.target.name]: event.target.value,
            typeDocument: pasaporteCheck
        });
    }
    const handleChangeName = event => {
        setProvider({
            ...provider,
            [event.target.name]: event.target.value.replace(/[&]/ig, ""),
        });
        getObject({
            ...provider,
            paisReceptor: foundCountry !== null ? foundCountry.codigo : null,
            ubicacionGeografica: selectedLocation !== null ? selectedLocation.idUbicacionGeografica : "",
            [event.target.name]: event.target.value,
            typeDocument: pasaporteCheck
        });
    }

    return (
        <Fragment>
            <Button variant="contained" color="primary" onClick={handleClickOpen}>
                <PersonAddIcon style={{ color: palette.primary.contrastText, paddingRight: '3%' }} fontSize="small" />  Agregar Proveedor
            </Button>
            <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}
                disableBackdropClick
                disableEscapeKeyDown
            >
                <DialogTitle id="max-width-dialog-title">Nuevo Proveedor</DialogTitle>
                <DialogContent>
                    <form
                        onSubmit={(event) => {
                            setOpenLoader(true);
                            handleSubmit(event);
                        }}
                    >
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            <Grid item md={12} xs={12}>
                                <label>
                                    Los campos marcados con ({" "}
                                    <font color={palette.error.main}> *</font> ) son obligatorios:
                                </label>
                            </Grid>
                            {msgError.show ? (
                                <Alert
                                    tipo={msgError.type}
                                    mensaje={msgError.msg}
                                    mesajeSubrayado={null}
                                    titulo={null}
                                    mostrar={msgError.show}
                                    cerrarAlerta={closeAlert}
                                />
                            ) : null}
                            <Grid item md={2} xs={12} className={classes.divForm}>
                                <label>
                                    Identificación: <font color={palette.error.main}>*</font>
                                </label>
                            </Grid>
                            <Grid item md={4} xs={12} className={classes.divInput}>
                                <input
                                    type="text"
                                    className={
                                        errors.idCliente
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    placeholder="Ej. 1234567890"
                                    name="idCliente"
                                    value={provider.idCliente}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.idCliente ? (
                                    <p className={classesApp.errorLetters}>{errors.idCliente}</p>
                                ) : null}
                            </Grid>
                            <Grid item md={6} xs={12} className={classes.divForm}>
                                <FormControl
                                    component="fieldset"
                                    className={classes.formControl}
                                >
                                    <RadioGroup
                                        aria-label="tipoDocumento"
                                        name="pasaporteCheck"
                                        className={classes.radio}
                                        required
                                        value={pasaporteCheck}
                                        //onChange={handleChangeCheck}
                                        onChange={(event) => {
                                            setPasaporteCheck(event.target.value);
                                        }}
                                    >
                                        <FormControlLabel
                                            value="P"
                                            control={
                                                <Radio
                                                    color="primary"
                                                    className={classes.radioButton}
                                                />
                                            }
                                            label="Pasaporte"
                                            labelPlacement="start"
                                            className={classes.radioLable}
                                        />
                                        <FormControlLabel
                                            value="C"
                                            control={
                                                <Radio
                                                    color="primary"
                                                    className={classes.radioButton}
                                                />
                                            }
                                            label="Cédula/RUC"
                                            labelPlacement="start"
                                            className={classes.radioLable}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={1} xs={12} className={classes.divForm}>
                                <label>
                                    Nombre: <font color={palette.error.main}>*</font>
                                </label>
                            </Grid>
                            <Grid item md={5} xs={12} className={classes.divInput}>
                                <input
                                    type="text"
                                    className={
                                        errors.nombres ? "form-control is-invalid" : "form-control"
                                    }
                                    placeholder="Ej. Juan Mauricio Pérez Calle"
                                    name="nombres"
                                    value={provider.nombres}
                                    onChange={handleChangeName}
                                    autoComplete="off"
                                />
                                {errors.nombres ? (
                                    <p className={classesApp.errorLetters}>{errors.nombres}</p>
                                ) : null}
                            </Grid>
                            <Grid item md={2} xs={12} className={classes.divForm}>
                                <label>
                                    Dígito verificador:
                                </label>
                            </Grid>
                            <Grid item md={4} xs={12} className={classes.divInput}>
                                <input
                                    type="number"
                                    className={
                                        errors.digitoVerificador
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    placeholder="Ej. 25"
                                    name="digitoVerificador"
                                    value={provider.digitoVerificador}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.digitoVerificador ? (
                                    <p className={classesApp.errorLetters}>
                                        {errors.digitoVerificador}
                                    </p>
                                ) : null}
                            </Grid>
                            <Grid item md={1} xs={12} className={classes.divForm}>
                                <label>
                                    Correo: <font color={palette.error.main}>*</font>
                                </label>
                            </Grid>
                            <Grid item md={5} xs={12} className={classes.divInput}>
                                <input
                                    type="email"
                                    className={
                                        errors.correoCliente
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    placeholder="Ej. user@ejemplo.com"
                                    name="correoCliente"
                                    value={provider.correoCliente}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.correoCliente ? (
                                    <p className={classesApp.errorLetters}>
                                        {errors.correoCliente}
                                    </p>
                                ) : null}
                            </Grid>
                            <Grid item md={2} xs={12} className={classes.divForm}>
                                <label>
                                    Tipo contribuyente:
                                </label>
                            </Grid>
                            <Grid item md={4} xs={12} className={classes.divInput}>
                                <select
                                    name="tipoContribuyente"
                                    className={
                                        errors.tipoContribuyente
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    value={provider.tipoContribuyente}
                                    onChange={handleChange}
                                >
                                    <option value="">--Seleccione--</option>
                                    <option value="1">Natural</option>
                                    <option value="2">Jurídico</option>
                                </select>
                                {errors.tipoContribuyente ? (
                                    <p className={classesApp.errorLetters}>
                                        {errors.tipoContribuyente}
                                    </p>
                                ) : null}
                            </Grid>
                            <Grid item md={1} xs={12} className={classes.divForm}>
                                <label>Dirección:</label>
                            </Grid>
                            <Grid item md={5} xs={12} className={classes.divInput}>
                                <input
                                    type="text"
                                    className={
                                        errors.direccion
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    placeholder="Ej. Av. República y Pradera"
                                    name="direccion"
                                    value={provider.direccion}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.direccion ? (
                                    <p className={classesApp.errorLetters}>{errors.direccion}</p>
                                ) : null}
                            </Grid>
                            <Grid item md={2} xs={12} className={classes.divForm}>
                                <label>
                                    Tipo receptor: <font color={palette.error.main}>*</font>
                                </label>
                            </Grid>
                            <Grid item md={4} xs={12} className={classes.divInput}>
                                <select
                                    name="tipoReceptor"
                                    className={"form-control"}
                                    value={provider.tipoReceptor}
                                    onChange={handleChange}
                                >
                                    <option value="01">Contribuyente</option>
                                    <option value="03">Gobierno</option>
                                    <option value="04">Extranjero</option>
                                </select>
                            </Grid>
                            <Grid item md={1} xs={12} className={classes.divForm}>
                                <label>Sucursal:</label>
                            </Grid>
                            <Grid item md={5} xs={12} className={classes.divInput}>
                                <input
                                    type="text"
                                    className={
                                        errors.sucursal ? "form-control is-invalid" : "form-control"
                                    }
                                    placeholder="Ej. 5264"
                                    name="sucursal"
                                    value={provider.sucursal}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.sucursal ? (
                                    <p className={classesApp.errorLetters}>{errors.sucursal}</p>
                                ) : null}
                            </Grid>
                            <Grid item md={2} xs={12} className={classes.divForm}>
                                <label>País extranjero:</label>
                            </Grid>
                            <Grid item md={4} xs={12} className={classes.divInput}>
                                <input
                                    type="text"
                                    className={
                                        errors.paisExtranjero
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    placeholder="Ej. Ecuador"
                                    name="paisExtranjero"
                                    value={provider.paisExtranjero}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.paisExtranjero ? (
                                    <p className={classesApp.errorLetters}>
                                        {errors.paisExtranjero}
                                    </p>
                                ) : null}
                            </Grid>
                            <Grid item md={1} xs={12} className={classes.divForm}>
                                <label>Teléfono:</label>
                            </Grid>
                            <Grid item md={5} xs={12} className={classes.divInput}>
                                <input
                                    type="number"
                                    className={
                                        errors.telefono ? "form-control is-invalid" : "form-control"
                                    }
                                    placeholder="Ej. 999-9999"
                                    name="telefono"
                                    value={provider.telefono}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.telefono ? (
                                    <p className={classesApp.errorLetters}>{errors.telefono}</p>
                                ) : null}
                            </Grid>
                            <Grid item md={2} xs={12} className={classes.divForm}>
                                <label>Coordenada sucursal:</label>
                            </Grid>
                            <Grid item md={4} xs={12} className={classes.divInput}>
                                <input
                                    type="text"
                                    className={
                                        errors.coordenadasSucursal
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    placeholder="Ej. 8.982189, -79.511994"
                                    name="coordenadasSucursal"
                                    value={provider.coordenadasSucursal}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.coordenadasSucursal ? (
                                    <p className={classesApp.errorLetters}>
                                        {errors.coordenadasSucursal}
                                    </p>
                                ) : null}
                            </Grid>
                            <Grid item md={1} xs={12} className={classes.divForm}>
                                <label>Ubicación geográfica:</label>
                            </Grid>
                            <Grid item md={5} xs={12} className={classes.divInput}>
                                {renderLocations()}
                            </Grid>
                            <Grid item md={2} xs={12} className={classes.divForm}>
                                <label>País receptor:</label> <font color={palette.error.main}>*</font>
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <Autocomplete
                                    id="pais"
                                    onChange={(e, value) => {
                                        setFoundCountry(value);
                                    }}
                                    open={openCountry}
                                    onOpen={() => {
                                        setOpenCountry(true);
                                    }}
                                    onClose={() => {
                                        setOpenCountry(false);
                                    }}
                                    getOptionDisabled={(option) =>
                                        option.codigo.includes(
                                            "No se encontró datos con el argumento ingresado"
                                        ) ||
                                        option.codigo.includes(
                                            "Error en la red al consultar el país."
                                        )
                                    }
                                    getOptionSelected={(option, value) =>
                                        option.codigo === value.codigo
                                    }
                                    getOptionLabel={(option) =>
                                        `${option.codigo} - ${option.nombre}`
                                    }
                                    options={options}
                                    noOptionsText={
                                        "No se encontró datos con el argumento ingresado"
                                    }
                                    //inputValue={foundClient}
                                    loadingText="Ingrese al menos 3 caracteres"
                                    loading={options.length === 0}
                                    renderInput={(params) => (
                                        <TextField
                                            className={
                                                foundCountry
                                                    ? foundCountry.codigo
                                                        ? "form-control  is-valid"
                                                        : null
                                                    : null
                                            }
                                            onChange={(event) => {
                                                if (event.target.value.length >= 2) {
                                                    searchCountry(event.target.value);
                                                }
                                            }}
                                            {...params}
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {loading ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                                <small style={{ color: "#818181" }}>
                                    También puede buscarlo por el código o nombre.
                                </small>
                                {errors.paisReceptor ? (
                                    <p className={classesApp.errorLetters}>
                                        {errors.paisReceptor}
                                    </p>
                                ) : null}
                            </Grid>
                            {foundCountry !== null && foundCountry.codigo === "ZZZ" ? (
                                <>
                                    <Grid item md={2} xs={12} className={classes.divForm}>
                                        <label>Nombre país receptor:</label>
                                    </Grid>
                                    <Grid item md={4} xs={12} className={classes.divInput}>
                                        <input
                                            type="text"
                                            className={
                                                errors.paisReceptorDesc
                                                    ? "form-control is-invalid"
                                                    : "form-control"
                                            }
                                            placeholder="Ej. Ecuador"
                                            name="paisReceptorDesc"
                                            value={provider.paisReceptorDesc}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                        {errors.paisReceptorDesc ? (
                                            <p className={classesApp.errorLetters}>
                                                {errors.paisReceptorDesc}
                                            </p>
                                        ) : null}
                                    </Grid>
                                </>
                            ) : null}

                            <Grid container spacing={3} justify="center">
                                <Grid item md={12} xs={12}>
                                    <Divider></Divider>
                                </Grid>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    className={classesGlobal.marginButton}
                                >
                                    Agregar
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleClose}
                                    className={classesGlobal.marginButton}
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </Dialog>
            <Backdrop className={classes.backdrop} open={openLoader} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Fragment>
    );
}

export default AddProviderBtn;